export default __webpack_public_path__ + "static/media/external.5e443988.svg";